/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React, { useEffect, useState } from 'react';
import { JssProvider, ThemeProvider, SheetsRegistry } from 'react-jss';
import { Provider } from 'react-redux';
import { useNetworkState, usePrevious } from 'react-use';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../utils/appInsights';
import jss from 'jss';
import preset from 'jss-preset-default';
import 'react-select/dist/react-select.css';
import theme from '../config/theme';
import '../style/index.css';
import store, { history } from './store';
import rootStyle from './style';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from '../config/msal-auth';
import { AuthRoutes } from './routes';
import SnackbarProvider from 'react-simple-snackbar';
import Modal from '../components/modal';
import ConnectionLost from '../components/ConnectionLostModal';
import GlobalMessage from '../components/GlobalMessage';

const setupJss = () => {
  jss.setup(preset());

  const styleSheet = { '@global': rootStyle };
  const globalStyleSheet = jss.createStyleSheet(styleSheet).attach();
  const sheetsRegistry = new SheetsRegistry();

  sheetsRegistry.add(globalStyleSheet);

  return sheetsRegistry;
};

const sheets = setupJss();

const Root = () => {
  const { online } = useNetworkState();
  const [showMessage, setShowMessage] = useState(undefined);
  const previousStatus = usePrevious(online);
  useEffect(() => {
    if (previousStatus !== undefined && online) {
      const content = (
        <GlobalMessage isSuccess showMsg={''}>
          {`Connection Restored`}
        </GlobalMessage>
      );
      setShowMessage(content);
    }
  }, [online]);

  return (
    <Provider store={store}>
      <JssProvider registry={sheets}>
        <ThemeProvider theme={theme}>
          <AppInsightsContext.Provider  value={reactPlugin}>
            <MsalProvider instance={msalInstance}>
              <SnackbarProvider>
                {!online && (
                  <Modal width="608px" height="347px">
                    <ConnectionLost />
                  </Modal>
                )}
                {showMessage}
                <AuthRoutes />
              </SnackbarProvider>
            </MsalProvider>
          </AppInsightsContext.Provider>
        </ThemeProvider>
      </JssProvider>
    </Provider>
  );
};

export default Root;
